module.exports = __webpack_public_path__ + "static/media/ambu.cc361a21.png";